import React from "react"

const ButtonsBar = props => {
  if (props.items.length < 2) return false

  const selectedClass = props.selectedClass || "btn btn-info";
  const normalClass = props.normalClass || "btn btn-default";
  
  const onClickButton = (e, index) => {
    e.preventDefault()
    if (index === props.selected) return

    props.onClick(index)
  }

  const buttons = props.items.map((item, index) =>
    <div className="buttons-bar__button" key={index} >
      <button className={index === props.selected ? selectedClass : normalClass}
        onClick={e => onClickButton(e, index)}>
        {item.name || item.title}
      </button>
    </div>
  )

  return (
    <div className={props.className}>
      {buttons}
    </div>
  )
}

export default ButtonsBar
